import React from 'react';
import { clsx } from 'clsx';
import { formatAmountWithSpacesAndSymbol } from '@/lib/amountUtils';
import { Slider } from '@/ui/components/Slider';
import styles from './InstallmentPeriodSelector.module.scss';

export interface InstallmentPeriodSelectorProps {
  monthlyPayment: number | undefined;
  period: number | undefined;
  onPeriodChange: (period: number) => void;
  className?: string;
  minPeriod: number;
  maxPeriod: number;
}

export const InstallmentPeriodSelector: React.FC<
  InstallmentPeriodSelectorProps
> = ({
  monthlyPayment,
  period,
  onPeriodChange,
  className,
  minPeriod,
  maxPeriod,
}) => {
  const monthlyPaymentFormatted = formatAmountWithSpacesAndSymbol(
    monthlyPayment,
    'lei'
  );

  const handleSliderChange = (value: number) => {
    onPeriodChange(value);
  };

  const formatPeriod = (periodValue: number) => {
    return `${periodValue} luni`;
  };

  const showRuler = maxPeriod - minPeriod >= 7;
  const rulerMajorTicks = showRuler
    ? Array.from({ length: maxPeriod / 6 }, (_, i) => minPeriod + i * 6)
    : undefined;

  return (
    <div className={clsx(styles.paymentCard, className)}>
      <div className={styles.paymentRow}>
        {/* Monthly Payment */}
        <div className={styles.paymentItem}>
          <p className={styles.paymentLabel}>Rata lunară</p>
          <div className={styles.paymentAmount}>{monthlyPaymentFormatted}</div>
        </div>

        {/* Period */}
        <div className={styles.paymentItem}>
          <p className={styles.paymentLabel}>Perioada</p>
          <div className={styles.paymentAmount}>
            <span className={styles.periodValue}>{period}</span>
            <span className={styles.periodUnit}>luni</span>
          </div>
        </div>
      </div>

      {/* Period Slider */}
      <Slider
        value={period ?? 0}
        step={1}
        min={minPeriod}
        max={maxPeriod}
        onChange={handleSliderChange}
        formatValue={formatPeriod}
        className={styles.slider}
        showRuler={showRuler}
        rulerMajorTicks={rulerMajorTicks}
      />
    </div>
  );
};
